import React from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";

import LinkedItem from "./components/LinkedItem";

import styles from "./styles";


const LinkedItemsList = ({classes, linkedItems, objectType, deleteLink, mainItemTypeId}) => {
  return (
    <Grid container>
      {linkedItems.map(item => (
        <Grid key={`${item.type_id}-${item.id}`} item xs={12} className={classes.assetCard}>
          <LinkedItem
            item={item}
            objectType={objectType}
            deleteLink={deleteLink}
            mainItemTypeId={mainItemTypeId}
          />
        </Grid>
      ))}
    </Grid>
  )
};

export default withStyles(styles)(LinkedItemsList);